/* Free gifts — the reminder in the cart drawer
   ---------------------------------------------------------------------------
   A "choose" promotion's chooser only exists on its qualifying products' pages.
   Anyone who adds one from a collection, a quick-add or a landing page build
   sheet reaches the cart having earned a gift and never having been shown it —
   so it is put back in front of them here, with the gifts inline, at the last
   moment where taking it is still free.

   Choose promotions only. An automatic promotion's gift is already in the cart
   by the time the drawer opens — gift-promo.js adds it by itself — so there is
   nothing to remind anyone about.

   Only one promotion is offered at a time: two gift panels stacked in a drawer
   read as clutter rather than as good news. Styled by sidecart-free-gift.css,
   named for the Kite-era panel whose look this kept. */

(function () {
  if (window.giftPromoSidecartLoaded) return;
  window.giftPromoSidecartLoaded = true;

  var BLOCK = "gp-sc-fg";
  var MARKER = "data-gp-sc-fg";
  // Above the line items, for the reason set out in sidecart-free-gift.css.
  var HOST = ".sc2-body";

  var giftsByPromo = {};
  var loading = {};
  var lastDetail = null;
  var queued = false;

  function sidecart() {
    return document.querySelector("sidecart-v2");
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function worth(gift) {
    if (gift.price == null || !window.GiftPromo) return "";
    return GiftPromo.money(gift.price);
  }

  // ── Rendering ─────────────────────────────────────────────────────────────

  function rowHTML(promoId, gift) {
    var value = worth(gift);
    return (
      '<li class="sc2-fg__row">' +
      (gift.image
        ? '<img class="sc2-fg__img" src="' + esc(gift.image) + '" alt="" width="38" height="38" loading="lazy">'
        : '<span class="sc2-fg__img sc2-fg__img--empty"></span>') +
      '<span class="sc2-fg__name">' +
      esc(gift.label || gift.title) +
      (value ? '<small class="sc2-fg__worth">Worth ' + esc(value) + "</small>" : "") +
      "</span>" +
      '<button type="button" class="sc2-fg__btn" data-gp-promo="' + esc(promoId) + '"' +
      ' data-gp-claim="' + esc(gift.variantId) + '">' +
      "Choose" +
      "</button></li>"
    );
  }

  /* The key makes a repaint a no-op. It has to change whenever the panel would
     render differently — including once the live prices arrive, which is why
     they are in it. */
  function keyFor(state, gifts) {
    return (
      state.id + "|" + (state.triggerTitle || "") + "|" +
      gifts.map(function (g) {
        return g.variantId + "@" + (g.price == null ? "?" : g.price);
      }).join(",")
    );
  }

  function blockHTML(state, gifts) {
    var sub = state.triggerTitle
      ? "Your " + esc(state.triggerTitle) + " comes with one of these, free. Pick the one you want."
      : "Pick the one you want.";

    return (
      '<div class="' + BLOCK + '" ' + MARKER + '="' + esc(keyFor(state, gifts)) + '">' +
      '<div class="sc2-fg__head">' +
      '<span class="sc2-fg__badge">Free gift</span>' +
      '<span class="sc2-fg__lead">You have a free gift waiting</span>' +
      "</div>" +
      '<p class="sc2-fg__sub">' + sub + "</p>" +
      '<ul class="sc2-fg__list">' +
      gifts.map(function (g) { return rowHTML(state.id, g); }).join("") +
      "</ul>" +
      '<p class="sc2-fg__error" hidden></p>' +
      "</div>"
    );
  }

  function removeBlock() {
    var existing = document.querySelector("." + BLOCK);
    if (existing) existing.remove();
  }

  function paint(state, gifts) {
    var sc = sidecart();
    if (!sc) return;
    var host = sc.querySelector(HOST);
    if (!host) return;

    var existing = host.querySelector("." + BLOCK);
    // Idempotent: an unchanged panel must not rewrite the DOM, or the observer
    // that puts it back after a re-render would drive itself in a loop.
    if (existing && existing.getAttribute(MARKER) === keyFor(state, gifts)) return;
    if (existing) existing.remove();

    host.insertAdjacentHTML("afterbegin", blockHTML(state, gifts));
    trackClarity("gift_promo_reminder_shown");
  }

  function setError(message) {
    var el = document.querySelector("." + BLOCK + " .sc2-fg__error");
    if (!el) return;
    el.textContent = message || "";
    el.hidden = !message;
  }

  function trackClarity(name) {
    if (typeof window.clarity !== "function") return;
    try { window.clarity("event", name); } catch (e) {}
  }

  // ── Claiming ──────────────────────────────────────────────────────────────

  // gift-promo.js redraws the cart itself once the gift is in, or once a
  // failed one is back out.
  function claim(button) {
    var buttons = document.querySelectorAll("." + BLOCK + " .sc2-fg__btn");
    Array.prototype.forEach.call(buttons, function (b) { b.disabled = true; });
    var label = button.textContent;
    button.textContent = "Adding…";
    setError("");

    window.GiftPromo.addGift(button.getAttribute("data-gp-promo"), button.getAttribute("data-gp-claim"))
      .then(function (result) {
        if (result.ok) {
          trackClarity("gift_promo_claimed");
          button.textContent = "Added ✓";
          return;
        }
        Array.prototype.forEach.call(buttons, function (b) { b.disabled = false; });
        button.textContent = label;
        setError(result.reason);
      })
      .catch(function () {
        Array.prototype.forEach.call(buttons, function (b) { b.disabled = false; });
        button.textContent = label;
        setError("We could not add that gift just now — nothing has been charged. Please try again.");
      });
  }

  // ── Wiring ────────────────────────────────────────────────────────────────

  // The first choose promotion this cart has earned and not yet taken.
  function waiting(detail) {
    return (detail.promotions || []).filter(function (state) {
      return state.promotion && state.promotion.mode === "choose" &&
        state.qualifies && !state.giftLine;
    })[0] || null;
  }

  function sync(detail) {
    lastDetail = detail;

    // An add in the air is about to make any panel wrong.
    var state = window.GiftPromo.busy ? null : waiting(detail);
    if (!state) {
      removeBlock();
      return;
    }

    var gifts = giftsByPromo[state.id];
    if (!gifts) {
      removeBlock();
      if (!loading[state.id]) {
        loading[state.id] = window.GiftPromo.options(state.id).then(function (list) {
          giftsByPromo[state.id] = list;
          if (lastDetail) sync(lastDetail);
        });
      }
      return;
    }
    if (!gifts.length) {
      removeBlock();
      return;
    }

    paint(state, gifts);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      if (lastDetail) sync(lastDetail);
    }, 250);
  }

  function start() {
    var sc = sidecart();
    if (!sc) return;

    sc.addEventListener("click", function (event) {
      var button = event.target.closest("[data-gp-claim]");
      if (button) claim(button);
    });

    document.addEventListener("gift-promo:change", function (event) {
      sync(event.detail);
    });

    /* The drawer replaces its own markup on every quantity change and refresh,
       which takes the panel with it — put it back whenever that happens. */
    new MutationObserver(schedule).observe(sc, { childList: true, subtree: true });

    window.GiftPromo.refresh();
  }

  function boot() {
    if (boot.done) return;
    if (!sidecart() || !window.GiftPromo) return;
    boot.done = true;
    start();
  }

  function watchForBoot() {
    boot();
    if (boot.done) return;
    var interval = setInterval(function () {
      boot();
      if (boot.done) clearInterval(interval);
    }, 400);
    setTimeout(function () { clearInterval(interval); }, 15000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchForBoot);
  } else {
    watchForBoot();
  }
})();
